import { useContext, useMemo } from 'react'

import { FrameBuilderSettingsContext } from '@frame-builder/contexts/settings-context'
import { FrameBuilderSelectedStateContext } from '@frame-builder/contexts/state-context'
import { getStateFrameSize } from '../size'
import { type EnabledFrameBuilderItemMap } from '../types'
import {
  getIsProfileValid,
  getIsPassepartoutColorEnabled,
} from './state-validation'

/**
 * Manages enabled frame builder item mapping.
 */
export const useEnabledItemMap = () => {
  const { selectedState } = useContext(FrameBuilderSelectedStateContext)
  const { frameBuilderConfiguration } = useContext(FrameBuilderSettingsContext)

  return useMemo<EnabledFrameBuilderItemMap>(() => {
    // Enabled profiles
    const enabledProfiles = frameBuilderConfiguration.profiles.filter(
      (profile) => {
        const frameSize = getStateFrameSize(selectedState)

        return getIsProfileValid(frameSize, profile)
      },
    )
    const enabledProfileIds = enabledProfiles.map((profile) => profile._id)

    // Enabled mount colors
    const enabledPassepartoutColors =
      frameBuilderConfiguration.passepartoutColors.filter(
        (passepartoutColor) => {
          return getIsPassepartoutColorEnabled(
            passepartoutColor,
            selectedState.profile,
          )
        },
      )
    const enabledPassepartoutColorIds = enabledPassepartoutColors.map(
      (passepartoutColor) => passepartoutColor._id,
    )

    return {
      profileIds: enabledProfileIds,
      passepartoutColorIds: enabledPassepartoutColorIds,
    }
  }, [frameBuilderConfiguration, selectedState])
}
